export default {
  route: 'Rota',
  vehicle: 'Araç',
  assignment: 'Atamalar',
  work: 'Çalışma Saatleri',
  break: 'Mola',
  dailyTotal: 'Günlük Toplam',
  sameStartEnd: 'Başlangıç ve bitiş saati aynı olamaz.',
  editAssignment: 'Atamayı Düzenle',
  repeat: 'Tekrar',
  handoverLocation: 'Devir Lokasyonu',
  addBreak: 'Mola Ekle',
  breakStart: 'Mola Başlangıç',
  breakEnd: 'Mola Bitiş',
  breakDuration: 'Mola Süresi',
  breakLocation: 'Mola Lokasyonu',
  assignmentDetails: 'Atama Detayları',
  hour: 'saat',
  description: 'Açıklama',
  deleteAssignment: 'Atamayı Sil',
  busyDriver: 'Meşgul',
  // VSER-14978: önceki günün gece yarısını geçen vardiyası
  continuesFrom: '{0} gününden devam ediyor',
  openDay: '{0} gününü aç',
  // VSER-14525: düzenleme ve silme diyalogları; kural metinlerinin kendisi sunucudan gelir
  change: {
    checking: 'Değişiklik kontrol ediliyor…',
    applying: 'Değişiklik uygulanıyor. Bu işlem bir dakika kadar sürebilir, lütfen sayfayı kapatmayın.',
    scopeTitle: 'Bu değişiklik hangi günlere uygulansın?',
    goToPlanning: 'Planlamaya Git',
    edit: 'Düzenle',
    delete: 'Sil',
    deleteAndContinue: 'Sil ve devam et',
    deleteQuestion: 'Bu atamayı silmek istediğinizden emin misiniz?',
    blockedFallback: 'Bu değişiklik uygulanamıyor.',
    resultTitle: 'Sonuç',
    rider: 'Yolcu',
    time: 'Saat',
    previousVehicle: 'Önceki Araç',
    outcome: 'Sonuç',
    failedCount: '{0} işlenemedi',
    timedOut:
      'Değişiklik beklenenden uzun sürüyor ve hâlâ işleniyor. Gün yeniden yüklenecek, tekrar denemeden önce atamayı kontrol edin.',
    genericError: 'Değişiklik uygulanamadı. Lütfen tekrar deneyin.',
    saved: 'Atama güncellendi.',
    deleted: 'Atama silindi.',
    // taşınan talebin yeni alış saati, kaç dakika sonra ya da önce
    minutes: '{0} dk',
    // devam eden vardiyanın kapsam sorusunda bugünün neden olmadığı
    todayLeftOut: {
      edit:
        'Bugünkü vardiya devam ediyor, bu yüzden bu değişiklik ancak yarından itibaren uygulanabilir. Bugün için burada yalnızca bitiş saati, mola ve açıklama değiştirilebilir; bugünün sürücüsünü değiştirmek için Planlama sayfasını kullanın.',
      delete:
        'Bugünkü vardiya devam ediyor ve üzerinde atanmış talepler var, bu yüzden ancak yarından itibaren silinebilir. Bugünkü talepleri aktarmak veya rotayı iptal etmek için Planlama sayfasını kullanın.',
    },
  },
};
